export default "__VITE_ASSET__DVv0BlM3__"